import { createContext } from 'react';

const WebAppContext = createContext(null);

export default WebAppContext;
